var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { memo, useState } from 'react';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { FaXTwitter, FaFacebook, FaReddit } from 'react-icons/fa6';
import { Popover, PopoverContent, PopoverTrigger } from 'root/src/client/v2/common/components/ui/popover';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from 'root/src/client/v2/common/components/ui/tooltip';
import { toast } from 'root/src/client/v2/common/components/ui/sonner';
import { cn } from 'root/src/client/v2/common/helpers/cn';
const ShareItem = ({ icon, label, onClick }) => (<button type="button" onClick={onClick} className="flex w-full items-center gap-2.5 rounded-md px-2.5 py-2 text-sm text-foreground transition-colors hover:bg-white/[0.06]">
		<span className="flex w-4 justify-center text-muted-foreground">{icon}</span>
		{label}
	</button>);
// Redesign share popover (replaces the legacy MUI/react-share ShareMenu): copy link + open the
// platform share intents in a new tab. Self-contained trigger (share icon button); reusable.
export const RedesignShareMenu = memo(({ url, className }) => {
    const [open, setOpen] = useState(false);
    const encoded = encodeURIComponent(url);
    const onCopy = () => __awaiter(void 0, void 0, void 0, function* () {
        setOpen(false);
        try {
            yield navigator.clipboard.writeText(url);
            toast.success('Link copied');
        }
        catch (_a) {
            toast.error('Could not copy link');
        }
    });
    const openShare = (shareUrl) => {
        setOpen(false);
        window.open(shareUrl, '_blank', 'noopener,noreferrer');
    };
    return (<Popover open={open} onOpenChange={setOpen}>
			<TooltipProvider delayDuration={200}>
				<Tooltip>
					<TooltipTrigger asChild>
						<PopoverTrigger asChild>
							<button type="button" aria-label="Share" className={cn('flex h-8 w-8 items-center justify-center rounded-lg border border-solid border-white/[0.08] bg-background/60 text-foreground backdrop-blur-md transition-colors hover:bg-background/80', className)}>
								<ShareOutlinedIcon sx={{ fontSize: 16 }}/>
							</button>
						</PopoverTrigger>
					</TooltipTrigger>
					<TooltipContent>Share</TooltipContent>
				</Tooltip>
			</TooltipProvider>
			<PopoverContent align="end" className="w-48 p-1">
				<ShareItem icon={<ContentCopyRoundedIcon sx={{ fontSize: 16 }}/>} label="Copy link" onClick={() => { void onCopy(); }}/>
				<ShareItem icon={<FaXTwitter size={15}/>} label="Share on X" onClick={() => openShare(`https://twitter.com/intent/tweet?url=${encoded}`)}/>
				<ShareItem icon={<FaFacebook size={15}/>} label="Facebook" onClick={() => openShare(`https://www.facebook.com/sharer/sharer.php?u=${encoded}`)}/>
				<ShareItem icon={<FaReddit size={15}/>} label="Reddit" onClick={() => openShare(`https://www.reddit.com/submit?url=${encoded}`)}/>
			</PopoverContent>
		</Popover>);
});
